import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MasterClientModel } from '@core/model/masterClient.model';
import { CommonService } from '@shared/service/common.service';

@Component({
  selector: 'app-modal-project-detail',
  templateUrl: './modal-project-detail.component.html',
  styleUrls: ['./modal-project-detail.component.scss']
})
export class ModalProjectDetailComponent implements OnInit {
  panelOpenState = false;
  infoProjects: MasterClientModel = new MasterClientModel();

  constructor(
    public dialogRef: MatDialogRef<ModalProjectDetailComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    public common: CommonService
  ) {
    if (this.data !== null && this.data !== undefined) {
      this.infoProjects = JSON.parse(JSON.stringify(this.data.infoProjects));
    }
  }

  ngOnInit() {

  }

  goBack(): void {
    this.dialogRef.close();
  }

}
